<template>
  <div class="subscription-card">
    <h2 class="subscription-title">Scegli il tuo piano MyStudio</h2>
    <div v-if="isLoading" class="skeleton-loader">
      <div class="skeleton skeleton-title"></div>
      <div class="skeleton skeleton-options"></div>
      <div class="skeleton skeleton-button"></div>
    </div>
    <div v-else class="plans-wrapper">
      <div class="plan-grid">
        <div
          class="plan-option"
          :class="getOptionClass('base')"
          @click="selectType('base')"
        >
          <div class="plan-badge">Base</div>
          <div v-if="currentPlan === 'base'" class="current-badge">ATTUALE</div>
          <h4 class="titleplan">Base</h4>
          <ul class="features">
            <li class="green">Piani dei Conti personalizzabili</li>
            <li class="green">
              Gestione dei privilegi e permessi dello studio
            </li>
          </ul>
          <div class="price-label">Gratuito</div>
        </div>
        <div
          class="plan-option"
          :class="getOptionClass('plus')"
          @click="selectType('plus')"
        >
          <div class="plan-badge">Plus</div>
          <div v-if="currentPlan === 'plus'" class="current-badge">ATTUALE</div>
          <h4 class="titleplan">
            Plus <i class="fa-solid fa-rocket icon-plan-plus"></i>
          </h4>
          <ul class="features">
            <li class="green">Piani dei Conti personalizzabili</li>
            <li class="green">
              Gestione dei privilegi e permessi dello studio
            </li>
            <li class="green">Importazione diretta con file .csv</li>
            <li class="green">Modifica Descrizione e Nomi Conto</li>
            <li class="green">Archivio completo dei Nomi Conto</li>
            <li class="green">Funzione "Carica Piano"</li>
            <li class="green">Condivisione del Piano di Conti con lo studio</li>
            <li class="green">Accesso alla cronologia delle operazioni</li>
          </ul>
          <div class="price-label">{{ prezzi.prezzo_piano_plus }}€ / anno</div>
        </div>
        <div
          class="plan-option"
          :class="getOptionClass('premium')"
          @click="selectType('premium')"
        >
          <div class="plan-badge">Premium</div>
          <div v-if="currentPlan === 'premium'" class="current-badge">
            ATTUALE
          </div>
          <h4 class="titleplan">
            Premium <i class="fa-solid fa-gem icon-plan-premium"></i>
          </h4>
          <ul class="features">
            <li class="green">Piani dei Conti personalizzabili</li>
            <li class="green">
              Gestione dei privilegi e permessi dello studio
            </li>
            <li class="green">Importazione diretta con file .csv</li>
            <li class="green">Modifica Descrizione e Nomi Conto</li>
            <li class="green">Archivio completo dei Nomi Conto</li>
            <li class="green">Funzione "Carica Piano"</li>
            <li class="green">
              Condivisione del Piano di Conti con il tuo studio
            </li>
            <li class="green">Suggerimenti intelligenti</li>
            <li class="green">Cronologia illimitata delle operazioni</li>
            <li class="green">Archivio scaricabile dei file convertiti</li>
          </ul>
          <div class="price-label">
            {{ prezzi.prezzo_piano_premium }}€ / anno
          </div>
        </div>
      </div>
      <button
        class="activate-button"
        @click="startPayment"
        :disabled="
          !planChangesEnabled ||
          guestMode ||
          !selectedType ||
          isProcessing ||
          !puoFareAcquisti ||
          selectedType === currentPlan
        "
      >
        <span v-if="isProcessing">
          <span class="spinner"></span> Elaborazione...
        </span>
        <span v-else-if="!planChangesEnabled">
          Cambio piano non disponibile
        </span>
        <span v-else-if="guestMode">Registrati per attivare</span>
        <span v-else-if="selectedType === currentPlan">Piano Attuale</span>
        <span v-else>Attiva ora</span>
      </button>
      <p v-if="!planChangesEnabled" class="permission-message">
        Il cambio piano è momentaneamente non disponibile.
      </p>
      <p v-else-if="guestMode" class="permission-message">
        Accedi o crea un account per scegliere un piano.
      </p>
      <p v-else-if="!puoFareAcquisti" class="permission-message">
        Contatta un Amministratore per gli acquisti.
      </p>
      <p
        v-if="
          planChangesEnabled && selectedType === currentPlan && puoFareAcquisti
        "
        class="status-message"
      >
        Questo è il tuo piano attuale.
      </p>
      <p v-if="message" class="status-message">{{ message }}</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from "@/config.js";

const PLAN_CHANGES_ENABLED = false;

export default {
  name: "SubscriptionPurchase",
  props: {
    loading: Boolean,
    guestMode: { type: Boolean, default: false },
  },
  data() {
    return {
      isLoading: true,
      planChangesEnabled: PLAN_CHANGES_ENABLED,
      selectedType: null,
      currentPlan: "base",
      isProcessing: false,
      puoFareAcquisti: false,
      userEmail: "",
      message: "",
      prezzi: {
        prezzo_piano_base: 0,
        prezzo_piano_plus: 0,
        prezzo_piano_premium: 0,
      },
    };
  },
  watch: {
    loading(newVal) {
      this.isProcessing = newVal;
    },
  },
  async mounted() {
    if (this.guestMode) {
      this.currentPlan = null;
      this.selectedType = "plus";
      this.puoFareAcquisti = false;
      await this.caricaPrezzi();
    } else {
      await Promise.all([
        this.fetchCurrentPlan(),
        this.checkUserPermission(),
        this.caricaPrezzi(),
      ]);
    }
    this.isLoading = false;
  },
  methods: {
    async caricaPrezzi() {
      try {
        const res = await axios.get(`${API_BASE_URL}/getPrezziConversione`);
        this.prezzi = {
          prezzo_piano_base: 0,
          prezzo_piano_plus: res.data.prezzo_piano_plus,
          prezzo_piano_premium: res.data.prezzo_piano_premium,
        };
      } catch (err) {
        console.error("Errore nel recupero dei prezzi:", err);
        this.message = "Errore nel caricamento dei prezzi.";
        setTimeout(() => {
          this.message = "";
        }, 3000);
      }
    },
    async fetchCurrentPlan() {
      if (this.guestMode) {
        this.currentPlan = null;
        this.selectedType = "plus";
        return;
      }

      try {
        const res = await axios.get(`${API_BASE_URL}/abbonamento`);
        this.currentPlan = res.data.current_plan;
        // Suggerisci il piano successivo
        if (this.currentPlan === "base") {
          this.selectedType = "plus";
        } else if (this.currentPlan === "plus") {
          this.selectedType = "premium";
        } else {
          this.selectedType = "premium"; // Se è già premium, resta su premium
        }
      } catch (err) {
        console.error("Errore nel recupero piano:", err);
        this.selectedType = "plus"; // Fallback su plus in caso di errore
      }
    },
    async checkUserPermission() {
      if (this.guestMode) {
        this.puoFareAcquisti = false;
        return;
      }

      this.userEmail = localStorage.getItem("userEmail");
      if (!this.userEmail) {
        this.puoFareAcquisti = false;
        return;
      }
      try {
        const response = await axios.get(`${API_BASE_URL}/user_permission`, {
          params: { email: this.userEmail },
        });
        this.puoFareAcquisti = response.data.puo_fare_acquisti;
      } catch (error) {
        console.error("Errore permessi acquisto:", error);
        this.puoFareAcquisti = false;
      }
    },
    selectType(type) {
      this.selectedType = type;
      this.message = "";
    },
    getOptionClass(type) {
      return this.selectedType === type ? `selected ${type}` : "";
    },
    getPrezzo(type) {
      if (type === "base") return 0;
      if (type === "plus") return this.prezzi.prezzo_piano_plus;
      if (type === "premium") return this.prezzi.prezzo_piano_premium;
      return 0;
    },
    async startPayment() {
      if (!this.planChangesEnabled) {
        this.message = "Il cambio piano è momentaneamente non disponibile.";
        return;
      }

      if (this.guestMode) {
        this.message = "Registrati o accedi per attivare un piano.";
        setTimeout(() => {
          this.message = "";
        }, 3000);
        return;
      }

      if (!this.selectedType) {
        this.message = "Seleziona un piano.";
        setTimeout(() => {
          this.message = "";
        }, 3000);
        return;
      }
      if (!this.puoFareAcquisti) {
        this.message = "Non hai i permessi per effettuare acquisti.";
        setTimeout(() => {
          this.message = "";
        }, 3000);
        return;
      }
      if (!this.userEmail) {
        this.message = "Devi essere loggato per attivare un piano.";
        setTimeout(() => {
          this.message = "";
        }, 3000);
        return;
      }
      if (this.selectedType === this.currentPlan) {
        this.message = "Questo è il tuo piano attuale.";
        setTimeout(() => {
          this.message = "";
        }, 3000);
        return;
      }
      this.isProcessing = true;
      this.message = "";
      const tipo_abbonamento = this.selectedType;
      const euro_pagati = this.getPrezzo(this.selectedType);
      try {
        if (
          process.env.VUE_APP_USE_STRIPE === "true" &&
          tipo_abbonamento !== "base"
        ) {
          const response = await axios.post(
            `${API_BASE_URL}/create-subscription-session`,
            {
              email: this.userEmail,
              tipo_abbonamento: tipo_abbonamento,
              euro_pagati: euro_pagati,
            }
          );
          window.location.href = response.data.url;
        } else {
          const response = await axios.post(
            `${API_BASE_URL}/purchase-subscription`,
            {
              email: this.userEmail,
              tipo_abbonamento: tipo_abbonamento,
              euro_pagati: euro_pagati,
            }
          );
          this.message =
            response.data.message ||
            `Abbonamento ${tipo_abbonamento} attivato con successo!`;
          this.currentPlan = tipo_abbonamento; // Aggiorna il piano attuale

          const userData = JSON.parse(localStorage.getItem("user") || "{}");
          if (userData.studio) {
            userData.studio.piano = tipo_abbonamento; // "plus" o "premium"
          } else {
            // Se per qualche motivo non c'è, creane uno minimo
            userData.studio = { piano: tipo_abbonamento, nome: "Studio" };
          }
          localStorage.setItem("user", JSON.stringify(userData));

          this.$emit("plan-updated", tipo_abbonamento); // Notifica aggiornamento
          this.$root.$emit("plan-updated", tipo_abbonamento);
          this.$emit("storage-updated"); // Aggiorna crediti
          setTimeout(() => {
            this.message = "";
            this.$emit("close"); // Chiusura automatica
          }, 3000);
        }
      } catch (err) {
        console.error("Errore attivazione abbonamento:", err);
        this.message = "Errore durante l'attivazione del piano.";
        setTimeout(() => {
          this.message = "";
        }, 4000);
      } finally {
        this.isProcessing = false;
      }
    },
  },
};
</script>

<style scoped>
.subscription-card {
  padding: 2rem;
  width: 82%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  transform: scale(1);
  scrollbar-color: rgb(216, 19, 9) !important;
}

.subscription-title {
  font-size: 1.8rem;
  letter-spacing: 1px;
  font-weight: 500;
  color: #1d1d1f;
  text-align: center;
  padding-top: 0.5rem;
  padding-bottom: 2rem;
}

.plans-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
  scrollbar-color: rgb(216, 19, 9) !important;
}

.plan-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;

  /* Forza tutte le card alla stessa altezza */
  align-items: stretch;
}

.plan-option {
  padding: 1.5rem;
  background: #ffffff;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid #e0e0e0;
  position: relative;

  /* NUOVO: rendiamo la card un flex container verticale */
  display: flex;
  flex-direction: column;
}
.plan-option > *:not(.plan-badge):not(.current-badge) {
  /* Tutti i figli diretti tranne i badge assoluti */
  position: relative;
  z-index: 1;
}

.plan-option:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.plan-option.selected.base {
  border-color: #c6c6c6;
  background: #eae7e7;
}

.plan-option.selected.plus {
  border-color: #96c6f9;
  background: #eff5ff;
}

.plan-option.selected.premium {
  border-color: #ffcc00;
  background: #fff9e6;
}
.icon-plan-plus,
.icon-plan-premium {
  margin-left: 5px;
}
.icon-plan-plus {
  color: rgb(39, 97, 164);
}
.icon-plan-premium {
  color: rgb(248, 157, 22);
}
.plan-badge {
  position: absolute;
  top: -10px;
  right: 15px;
  background: #6e6e6e;
  color: #fff;
  padding: 0.3rem 1rem;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 500;
}

.current-badge {
  position: absolute;
  top: 16px;
  left: 20px;
  background: #e2e2e2b3;
  color: #575757;
  /* background: #dcdbff;
  color: #615eeb; */
  font-family: ui-sans-serif, -apple-system, system-ui, Segoe UI, Helvetica,
    Apple Color Emoji, Arial, sans-serif, Segoe UI Emoji, Segoe UI Symbol;
  padding: 0.35rem 0.6rem;
  border-radius: 18px;
  font-size: 0.8rem;
  font-weight: 500;
}

.plan-option.plus .plan-badge {
  background: #007aff;
}

.plan-option.premium .plan-badge {
  background: #ffcc00;
  color: #1d1d1f;
}

h4 {
  font-size: 1.5rem;
  color: #1d1d1f;
  margin-bottom: 1.5rem;
  text-align: center;
}

.features {
  list-style: none;
  padding: 0;
  margin: 0 0 1.5rem;
  font-size: 0.9rem;
  line-height: 1.5rem;
  color: #2d2d2d;
  text-align: left;
}

.features li {
  margin-bottom: 0.75rem;
  padding-left: 1.55rem; /* Spazio per il simbolo ✔ o ✖ */
  position: relative; /* Per posizionare il simbolo ::before */
  font-family: ui-sans-serif, -apple-system, system-ui, Segoe UI, Helvetica,
    Apple Color Emoji, Arial, sans-serif, Segoe UI Emoji, Segoe UI Symbol;
}

.features li::before {
  content: "";
  position: absolute;
  left: 0;
  font-family: sans-serif;
}

.features li.green::before {
  content: "✔";
  color: #28a745; /* Verde per le spunte */
  font-size: 1.1rem;
}

.features li.red::before {
  content: "✖";
  color: #dc3545; /* Rosso per le X */
  font-size: 1.1rem;
}

.price-label {
  font-size: 1.3rem; /* un po' più grande, come si vede spesso */
  font-weight: 700;
  color: #1d1d1f;
  text-align: center;
  padding: 0.8rem 1rem;
  background: #f5f5f7;
  border-radius: 12px;
  margin: 0 auto;
  width: fit-content;

  /* Questo è il trucco principale */
  margin-top: auto; /* spinge il prezzo in fondo */
  margin-bottom: 0.5rem; /* piccolo spazio dal fondo */
}
/* Opzionale: rendiamo il titolo più centrato e con margine fisso */
.titleplan {
  margin-top: 2.5rem; /* compensa lo spazio del badge "ATTUALE" */
  margin-bottom: 1rem;
  text-align: center;
}

.activate-button {
  display: block;
  margin: 0 auto 1rem;
  padding: 0.75rem 2rem;
  font-size: 1.1rem;
  font-weight: 500;
  background: linear-gradient(90deg, #007aff 0%, #2997ff 100%);
  color: #fff;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: opacity 0.3s ease;
  width: 100%;
  max-width: 300px;
}

.activate-button:disabled {
  background: #b0b0b0;
  cursor: not-allowed;
}

.activate-button:hover:not(:disabled) {
  opacity: 0.9;
}

.permission-message,
.status-message {
  text-align: center;
  margin-top: 1rem;
  font-size: 0.9rem;
}

.status-message {
  color: #007aff;
  font-weight: 500;
}

.permission-message {
  color: #6e6e6e;
}

.spinner {
  border: 2px solid #fff;
  border-top-color: transparent;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  display: inline-block;
  margin-right: 0.5rem;
  animation: spin 0.8s linear infinite;
  vertical-align: middle;
}

.skeleton-loader {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 2rem;
}

.skeleton {
  background: #e0e0e0;
  border-radius: 8px;
  animation: pulse 1.5s infinite ease-in-out;
}

.skeleton-title {
  height: 2rem;
  width: 40%;
  margin: 0 auto 2rem;
}

.skeleton-options {
  height: 250px;
  width: 100%;
}

.skeleton-button {
  height: 3rem;
  width: 150px;
  align-self: center;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .plan-grid {
    grid-template-columns: 1fr;
  }
  .activate-button {
    width: 100%;
  }
}
</style>
